module.exports = __webpack_public_path__ + "static/img/ershi.fe171f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ershi.png
// module id = At5c
// module chunks = 1